// extracted by mini-css-extract-plugin
export default {"root":"ProductSpotlight_root__1djNV"};